// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disclaimer {
  max-width: 800px;
  width: 100%; /* ✅ Add this */
  margin: 60px auto 100px;
  padding: 40px 20px;
  background-color: #0d0d0d;
  color: #f2f2f2;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.7;
  font-size: 1rem;
  box-shadow: 0 4px 15px rgba(247, 147, 26, 0.8);
  border-radius: 8px;
  box-sizing: border-box; /* ✅ Ensure padding doesn't overflow */
  overflow-wrap: break-word; /* ✅ Prevent long text from breaking layout */
}


.disclaimer h2 {
  font-size: 2rem;
  margin-bottom: 20px;
  color: #f7931a;
  text-align: center;
  font-weight: 600;
  border-bottom: 2px solid #f7931a;
  padding-bottom: 10px;
}

.disclaimer p {
  margin-bottom: 20px;
  text-align: justify;
}

/* Responsive Design */
@media (max-width: 768px) {
  .disclaimer {
    padding: 30px 15px;
    font-size: 0.95rem;
  }

  .disclaimer h2 {
    font-size: 1.6rem;
  }
}

@media (max-width: 480px) {
  .disclaimer {
    padding: 20px 10px;
    font-size: 0.9rem;
  }

  .disclaimer h2 {
    font-size: 1.4rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/css/Overview.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW,EAAE,eAAe;EAC5B,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,4DAA4D;EAC5D,gBAAgB;EAChB,eAAe;EACf,8CAA8C;EAC9C,kBAAkB;EAClB,sBAAsB,EAAE,sCAAsC;EAC9D,yBAAyB,EAAE,6CAA6C;AAC1E;;;AAGA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".disclaimer {\n  max-width: 800px;\n  width: 100%; /* ✅ Add this */\n  margin: 60px auto 100px;\n  padding: 40px 20px;\n  background-color: #0d0d0d;\n  color: #f2f2f2;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  line-height: 1.7;\n  font-size: 1rem;\n  box-shadow: 0 4px 15px rgba(247, 147, 26, 0.8);\n  border-radius: 8px;\n  box-sizing: border-box; /* ✅ Ensure padding doesn't overflow */\n  overflow-wrap: break-word; /* ✅ Prevent long text from breaking layout */\n}\n\n\n.disclaimer h2 {\n  font-size: 2rem;\n  margin-bottom: 20px;\n  color: #f7931a;\n  text-align: center;\n  font-weight: 600;\n  border-bottom: 2px solid #f7931a;\n  padding-bottom: 10px;\n}\n\n.disclaimer p {\n  margin-bottom: 20px;\n  text-align: justify;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .disclaimer {\n    padding: 30px 15px;\n    font-size: 0.95rem;\n  }\n\n  .disclaimer h2 {\n    font-size: 1.6rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .disclaimer {\n    padding: 20px 10px;\n    font-size: 0.9rem;\n  }\n\n  .disclaimer h2 {\n    font-size: 1.4rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
